export const GET_ERROR_LOGS = "GET_ERROR_LOGS";
export const IS_LOADING = "IS_LOADING";
